// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/personal-minimums.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/personal-minimums/personal-minimums.js';

mount([g0]);
